export const appBaseRoute = ``;

const appRoutesUrls = {
  main: `${appBaseRoute}/`,
};

export default appRoutesUrls;
